/**
 * Approval Disclaimers Configuration
 * 
 * Approval disclaimers are disclaimers that require explicit user confirmation
 * before proceeding with offer selection. They are distinct from regular
 * informational disclaimers.
 * 
 * To add a new approval disclaimer:
 * 1. Add a new entry to the approvalDisclaimers array below
 * 2. Add corresponding intl messages to src/messages/he.js with keys:
 *    - approvalDisclaimers.<provider>.<country>.title
 *    - approvalDisclaimers.<provider>.<country>.text
 */

export const approvalDisclaimers = [
  {
    provider: 'HAREL',
    countries: ['SAUDI ARABIA'],
    titleKey: 'approvalDisclaimers.harel.restrictedCountries.title',
    textKey: 'approvalDisclaimers.harel.restrictedCountries.text',
    logo: 'HarelLogo',
  },
  // Add new approval disclaimers here - no code changes needed:
  // {
  //   provider: 'CLAL',
  //   countries: ['SOME_COUNTRY'],
  //   titleKey: 'approvalDisclaimers.clal.someCountry.title',
  //   textKey: 'approvalDisclaimers.clal.someCountry.text',
  //   logo: 'ClalLogo',
  // },
];

/**
 * Find an approval disclaimer for a given provider and selected countries
 * @param {string} provider - The insurance provider code (e.g., 'HAREL', 'CLAL')
 * @param {string[]} selectedCountries - Array of selected country codes
 * @returns {object|undefined} The matching disclaimer config or undefined
 */
export const findApprovalDisclaimerForOffer = (provider, selectedCountries) =>
  approvalDisclaimers.find(
    (disclaimer) =>
      disclaimer.provider === provider &&
      disclaimer.countries.some((country) => selectedCountries.includes(country))
  );
